export const DEBOUNCE_WAIT_TIME = 300;

export const BRANDWORKZ_MARKETING_WEBSITE_DOMAIN = 'https://www.brandworkz.com';
